import { render } from "./TheFleetCreation.vue?vue&type=template&id=64bbf77b"
import script from "./TheFleetCreation.vue?vue&type=script&lang=js"
export * from "./TheFleetCreation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__